export const DOWNLOAD_APP_URL = "https://www.dakotaprep.com/download";
